import { ContactAPI } from '@business/api/contact';
import { EmailAPI } from '@business/api/email';
import { ContactActivityPageQuery, ContactActivityRequest, ContactActivityResponse } from '@business/entities/contact';
import { SendEmailRequest } from '@business/entities/gmail_messages';
import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { R } from '@core/utils/r';
import { Repository } from '@core/utils/repository';
import { pipeIf } from '@core/utils/rxjs/operators';
import { map, switchMap } from 'rxjs/operators';
import { OrderActivityPageQuery } from '@business/entities/order';
import { TimeMaterialActivityResponse } from '@business/entities/tm/TimeMaterialActivityResponse';
import { TimeMaterialAPI } from '@business/api/timeMaterial';

export class TimeMaterialActivityBloc extends BaseBloc {
  private readonly activityRepo = new Repository<TimeMaterialActivityResponse>({
    getItemId: activty => activty.id,
    pagenated: true,
  });

  readonly activities$ = this.activityRepo.items$.pipe(map(items => R.sortBy(items, item => -item.createdAt)));

  onReset() {
    this.activityRepo.reset();
  }

  fetchPaginateActivities = (options: OrderActivityPageQuery) => {
    return TimeMaterialAPI.fetchPaginateActivities(options);
  };

  fetchActivities = (options: OrderActivityPageQuery) => {
    if (options.page === 1) {
      this.activityRepo.ops.reset();
    }
    return TimeMaterialAPI.fetchActivities(options).pipe(
      pipeIf((options.page === 1 || options.page === undefined) && this.activityRepo.ops.reset()),
      pipeIf(options.page !== undefined && options.page > 1 && this.activityRepo.ops.upsertMany(item => ({ item }))),
      handleMessage({ error: requestMessage('fetch_activities_error') }),
    );
  };
}
